<template>
  <div
    class="form-group"
    :class="{'cost-input':isCost}"
  >
    <div class="label">
      <label
        v-if="label"
        :for="id"
        class="font-bold"
        v-html="label"
      >
      </label>
      <span v-if="required">*</span>
      <Hint
        v-if="hint"
        :textHint="hint"
        :bgColor="hintBgColor"
        :image="hintImage"
        :description="hintDescription"
      />
      :
    </div>

    <div class="flex items-center">
      <input
        v-bind="$attrs"
        :id="id"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder||label"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <span
        v-if="hintInput"
        class="ml-2 text-xs text-gray-400"
      >{{hintInput}}</span>
    </div>
    <ValidationErrors :errors="errors" />
  </div>
</template>
<script>
export default {
  emits: ['update:modelValue'],
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },

    placeholder: {
      type: [String, Number],
      default: "",
    },
    isCost: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
      default: "",
    },
    hintBgColor: {
      type: String,
      default: "",
    },
    hintImage: {
      type: String,
      default: "",
    },
    hintDescription: {
      type: String,
      default: "",
    },
    hintInput: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.form-group label > *,
.form-group .label > * {
  display: inline-block;
}
.form-group.cost-input label {
  color: #25a24c;
}
.form-group.cost-input input[type="number"],
.form-group.cost-input input[type="text"] {
  border-color: #25a24c;
}
</style>
